import { Link } from "react-router-dom";

type BlockNumberProps = {
  height: number;
  link?: boolean;
};

function BlockNumber({ height, link }: BlockNumberProps) {
  return (
    <span className="text-small text-green-900">
      {link ? (
        <Link to={`/block/${height}`}>{height.toLocaleString("en-US")}</Link>
      ) : (
        height.toLocaleString("en-US")
      )}
    </span>
  );
}

export default BlockNumber;
